import { faBrainCircuit, faMemoPad, faMessagesQuestion, faThumbsUp } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import QuickCopyButton from '../common/QuickCopyButton';
import FavoriteButtonContainer from '@/components/favorites/FavoriteButtonContainer';
import React from 'react';

interface TenderNavbarProps {
  tenderId: string;
  isActive: boolean;
  hasDocuments: boolean;
  quickCopyText: string;
  isAuthenticated: boolean;
  shortlistId: string | null;
  shortlistEntryId: string | null;
  setIsSidebarOpenedOnMobile: (arg0: boolean) => void;
  onSectionClick?: (section: string) => void;
}

const TenderNavbar: React.FC<TenderNavbarProps> = ({
  tenderId,
  isActive,
  hasDocuments,
  quickCopyText,
  isAuthenticated,
  setIsSidebarOpenedOnMobile,
  shortlistId,
  shortlistEntryId,
  onSectionClick,
}) => {
  const handleSectionClick = (section: string) => {
    setIsSidebarOpenedOnMobile(true);
    if (onSectionClick) {
      onSectionClick(section);
    }
  };

  return (
    <div className="card mb-4 w-full rounded-lg bg-base-200">
      <div className={`flex w-full items-center justify-around gap-1`}>
        <div>
          <QuickCopyButton text={quickCopyText} />
        </div>
        {isAuthenticated && (
          <div>
            <FavoriteButtonContainer tenderId={tenderId} shortlistId={shortlistId} initEntryId={shortlistEntryId} />
          </div>
        )}

        <button
          className="flex h-10 w-10 items-center justify-center"
          aria-label="Toggle Menu"
          onClick={() => handleSectionClick('kiScore')}
        >
          <FontAwesomeIcon className="h-6 w-6" icon={faBrainCircuit} />
        </button>
        <button
          className="flex h-14 w-14 items-center justify-center"
          aria-label="Toogle Menu"
          onClick={() => handleSectionClick('teamVotes')}
        >
          <FontAwesomeIcon className="h-6 w-6" icon={faThumbsUp} />
        </button>
        {isActive && hasDocuments && (
          <button
            className="flex h-10 w-10 items-center justify-center"
            aria-label="Toggle Menu"
            onClick={() => handleSectionClick('kiChats')}
          >
            <FontAwesomeIcon className="h-6 w-6" icon={faMessagesQuestion} />
          </button>
        )}
        <button
          className="flex h-10 w-10 items-center justify-center"
          aria-label="Toggle Menu"
          onClick={() => handleSectionClick('notesAndComments')}
        >
          <FontAwesomeIcon className="h-6 w-6" icon={faMemoPad} />
        </button>
      </div>
    </div>
  );
};

export default TenderNavbar;
